import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { useToggle } from '@hooks/toggle/useToggle';
import Image from 'next/image';
import React, { useState } from 'react';

// TODO :  나중에 HTML로 처리해야함.
export type FaqContentItemInfo = {
  title: string;
  content: React.ReactNode[];
  contentHtml: string;
};

const FaqContentTextWrapper = styled.div`
  display: flex;
  padding: 10px 12px;
`;

const FaqContentQuestionTextWrapper = styled(FaqContentTextWrapper)`
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  cursor: pointer;
`;

const FaqContentAnswerTextWrapper = styled(FaqContentTextWrapper)`
  flex-direction: column;
`;

type Props = {
  readonly item: FaqContentItemInfo;
};

export default function FaqContentItem({ item }: Props) {
  const toggle = useToggle();

  return (
    <>
      <FaqContentQuestionTextWrapper onClick={() => toggle.toggle()}>
        <Typography variant={TypoVariant.MH3}>{item.title}</Typography>
        {toggle.isToggled ? (
          <Image src="/assets/images/arrow_on.png" alt="answer-image" width={24} height={24} />
        ) : (
          <Image src="/assets/images/arrow_off.png" alt="answer-image" width={24} height={24} />
        )}
      </FaqContentQuestionTextWrapper>
      {toggle.isToggled && (
        <FaqContentAnswerTextWrapper>
          {item.content.map((answer, answerIndex) =>
            typeof answer === 'object' ? (
              answer
            ) : (
              <Typography variant={TypoVariant.B3} key={answerIndex}>
                {answer}
              </Typography>
            ),
          )}
        </FaqContentAnswerTextWrapper>
      )}
    </>
  );
}
